import request from '@/utils/request'

export function getMenuTree() {
  return request({
    url: '/Menu/tree',
    method: 'get'
  })
}
export function getMenuList(form) {
  return request({
    url: '/Menu/page',
    method: 'get',
    params:form
  })
}

export function addMenu(data) {
  return request({
    url: '/Menu',
    method: 'post',
    data
  })
}

export function updateMenu(data) {
  return request({
    url: `/Menu/${data.id}`,
    method: 'put',
    data
  })
}

export function deleteMenu(id) {
  return request({
    url: `/Menu/${id}`,
    method: 'delete'
  })
}